import { contentType } from '../../../utils/ActionTypes';
import { createReducerWraper } from '../../../utils/Reducer';

export const transactionListReducer = createReducerWraper(contentType.TRANSACTION_LIST);
